<template>
  <div>
    <Header title="调课批量审核"></Header>
    <qz-list
      ref="qzlist"
      titleProp="wfexname"
      :listData.sync="listData"
      :listProps.sync="listProps"
      @goDetail="goDetail"
    >
      <template #bottom="scoped">
        <div class="qzlist-bottom">
          <div>申请时间：{{ scoped.item.cjsj }}</div>
        </div>
      </template>
    </qz-list>
    <div class="cjlrDetail-button">
      <van-button type="primary" round @click="pass">
        批量审核
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listData: []
    };
  },
  created() {
    this.listData = JSON.parse(this.$route.params.route_params);
  },
  computed: {
    listProps: {
      get() {
        return [
          {
            label: "教室类型",
            prop: "gnqmc",
            type: "col"
          },
          {
            label: "容纳人数",
            prop: "syrs",
            type: "col"
          },
          {
            label: "借用周次",
            prop: "kkzc",
            type: "col"
          },
          {
            label: "借用星期",
            prop: "xq",
            type: "col"
          },
          {
            label: "借用节次",
            prop: "kcsj"
          }
        ];
      }
    }
  },
  methods: {
    goDetail(val) {
      val.type = "detail";
      this.$router.push({
        name: "tkshDetail",
        params: { route_params: JSON.stringify(val) }
      });
    },
    pass() {
      let arr = this.listData.map(item => item.id);
      let obj = {
        id_sh: arr.join(","),
        xq_id: this.listData[0].ywinstanceid,
        sh_flag: "009",
        route: "/tksh/index"
      };
      this.$router.push({
        name: "tkshCommompass",
        params: {
          route: "adjustListDetail,1",
          route_params: encodeURI(JSON.stringify(obj))
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.qzlist-bottom {
  padding-top: 11.5px;
  display: flex;
  justify-content: space-between;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  font-weight: 400;
  margin-bottom: -2px;
  margin-top: 11.5px;
  border-top: 1px solid #e5e5e5;
  .qzlist-revoke {
    position: relative;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #7469f8;
    letter-spacing: 0;
    margin-left: 16px;
    font-weight: 400;
    line-height: 20px;
    &::before {
      content: "";
      height: 14px;
      position: absolute;
      border-left: 1px solid #e6e6e6;
      top: 4px;
      left: -9px;
    }
  }
}
.cjlrDetail-button {
  position: fixed;
  display: flex;
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: #fff;
  padding: 10px 15px;
  &::before {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    top: 0;
    left: 16px;
    border-top: 1px solid #e5e5e5;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
  .van-button {
    width: calc(~'100% - 30px');
    height: 50px;
    background: #7469f8;
    & + .van-button {
      margin-left: 15px;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/tksh/plsh.vue